import "./App.css";
import "./index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import Home from "./components/Home";
import AboutPage from "./components/about/AboutPage";
import ServicesPage from "./components/services/ServicesPage";
import ContactPage from "./components/contact/ContactPage";
import LoginPage from "./components/auth/LoginPage";
import SignupPage from "./components/auth/SignupPage";
import ForgotPasswordPage from "./components/auth/ForgotPasswordPage";
import ResetPasswordPage from "./components/auth/ResetPasswordPage";
import EmailConfirmationPage from "./components/auth/EmailConfirmationPage";
import AuthCallback from "./components/auth/AuthCallback";
import OnboardingPage from "./components/auth/OnboardingPage";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import AdminRoute from "./components/admin/AdminRoute";
import DashboardPage from "./components/dashboard/DashboardPage";
import EditProfilePage from "./components/profile/EditProfilePage";
import ArtistWebPage from "./components/artistweb/ArtistWebPage";
import ArtistProfilePage from "./components/artistweb/ArtistProfilePage";
import FaqPage from "./components/faq/FaqPage";
import FaqDetailPage from "./components/faq/FaqDetailPage";
import TermsPage from "./components/legal/TermsPage";
import PrivacyPolicyPage from "./components/legal/PrivacyPolicyPage";
import ShippingReturnsPage from "./components/legal/ShippingReturnsPage";
import NotFoundPage from "./components/common/NotFoundPage";
import CookieConsent from "./components/common/CookieConsent";
import DistributionPage from "./components/distribution/DistributionPage";
import DraftsPage from "./components/dashboard/DraftsPage";
import AdminPage from "./components/admin/AdminPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public SEO-indexed multi-page routes */}
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/artists" element={<ArtistWebPage />} />
            <Route path="/artist-web" element={<ArtistWebPage />} />
            <Route path="/artist/:slug" element={<ArtistProfilePage />} />
            <Route path="/artist" element={<ArtistProfilePage />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/faq/:slug" element={<FaqDetailPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/shipping-returns" element={<ShippingReturnsPage />} />

            {/* Auth routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/email-confirmation" element={<EmailConfirmationPage />} />
            <Route path="/auth/callback" element={<AuthCallback />} />

            {/* Protected routes */}
            <Route
              path="/onboarding"
              element={
                <ProtectedRoute>
                  <OnboardingPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-profile"
              element={
                <ProtectedRoute>
                  <EditProfilePage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/distribution"
              element={
                <ProtectedRoute>
                  <DistributionPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/distribution/*"
              element={
                <ProtectedRoute>
                  <DistributionPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/submission"
              element={
                <ProtectedRoute>
                  <DistributionPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/submission/*"
              element={
                <ProtectedRoute>
                  <DistributionPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/drafts"
              element={
                <ProtectedRoute>
                  <DraftsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/artist-web/drafts"
              element={
                <ProtectedRoute>
                  <DraftsPage />
                </ProtectedRoute>
              }
            />

            {/* Admin Panel ,  requires role = admin */}
            <Route
              path="/admin"
              element={
                <AdminRoute>
                  <AdminPage />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/*"
              element={
                <AdminRoute>
                  <AdminPage />
                </AdminRoute>
              }
            />

            {/* Placeholder protected routes ,  redirect to dashboard for now */}
            {[
              '/bid-marketplace',
              '/find-collab',
              '/portfolio',
              '/creator-tools',
              '/followers',
              '/pricing',
              '/wallet',
              '/orders',
            ].map((path) => (
              <Route
                key={path}
                path={path}
                element={
                  <ProtectedRoute>
                    <DashboardPage />
                  </ProtectedRoute>
                }
              />
            ))}

            {/* 404 Catch-All Route */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>

          {/* Cookie consent ,  renders on all pages, outside Routes */}
          <CookieConsent />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
